export const voluntarySupport = {
  cashAppUrl: 'https://cash.app/$quisinart',
  cashTag: '$quisinart',
  qrCodePath: '/support/cash-app-quisinart.svg',
  recipientLabel: 'John N. Farmer · OMIKINA founder and accountable publisher',
  purposeLabel: 'OMIKINA voluntary-support destination',
} as const
